export const WhatIsFSBO = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold mb-6 text-gray-900">
              What Is For Sale by Owner for Apartment Buildings?
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              For Sale by Owner (FSBO) means selling your apartment building directly to a buyer without using a real estate agent or broker. For commercial properties like apartment buildings, this approach can save you substantial money in commissions while giving you complete control over the sale process.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Unlike residential FSBO sales, selling an apartment building for sale by owner typically involves working directly with experienced investors or buyers who understand commercial real estate. This eliminates the need for multiple showings, open houses, and the complications that come with traditional listing methods.
            </p>
            <div className="bg-teal-50 border-l-4 border-teal-500 p-6 rounded-r-lg">
              <h3 className="font-bold text-gray-900 mb-2">Key Difference:</h3>
              <p className="text-gray-700">
                Commercial apartment building sales are fundamentally different from residential home sales. Buyers are sophisticated investors who evaluate properties based on income potential, not emotional appeal. This makes FSBO particularly effective for multifamily properties.
              </p>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/a34f56dbdf6aa609977fe0de2c199839.jpg"
              alt="For sale by owner apartment building owner managing sale"
              className="w-full h-full rounded-lg shadow-xl object-cover"
            />
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="bg-gray-50 rounded-lg p-8">
            <div className="w-16 h-16 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-money-dollar-circle-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900">Save Commission Costs</h3>
            <p className="text-gray-700">
              Avoid paying 5-6% in broker commissions, which can amount to hundreds of thousands of dollars on apartment building sales.
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-8">
            <div className="w-16 h-16 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900">Maintain Control</h3>
            <p className="text-gray-700">
              You decide who sees your property, when showings occur, and how the sale is structured without agent interference.
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-8">
            <div className="w-16 h-16 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-user-heart-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900">Direct Communication</h3>
            <p className="text-gray-700">
              Work directly with the buyer to negotiate terms, structure deals, and address concerns without middlemen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};